import { UsersSearchInputProps } from './users-search-input.types'
import { EntitySearchInput } from 'components'
import { observer } from 'mobx-react-lite'
import { useRootStore } from 'mobx-stores/store-provider'
import { useEffect } from 'react'

const UsersSearchInputComponent = (props: UsersSearchInputProps) => {
  const { className, style, excludeUsersFromSearchResults } = props
  const {
    userSearchStore: {
      searchInput,
      onSearchInputChange,
      searchResultsFiltered,
      noResultsMessage,
      onComponentMount,
      clearStore
    },
    routingStore: { push }
  } = useRootStore()

  useEffect(() => {
    onComponentMount()
    return clearStore
  }, [onComponentMount, clearStore])

  const searchResults = searchResultsFiltered(excludeUsersFromSearchResults)

  return (
    <EntitySearchInput
      className={className}
      style={style}
      inputLabel='Add a user'
      inputProps={{
        placeholder: 'Search for a user...',
        value: searchInput,
        onChange: onSearchInputChange
      }}
      noResultsMessage={noResultsMessage}
      searchResults={searchResults}
      addNewEntityProps={{
        addButtonProps: {
          children: 'Add a new user',
          onClick: () => push('/user-management/add-user')
        }
      }}
    />
  )
}

const UsersSearchInput = observer(UsersSearchInputComponent)
export { UsersSearchInput }
